import api from './api';

export const authService = {
  login: async (email, password, recaptchaToken) => {
    const response = await api.post('/accounts/login/', {
      email,
      password,
      recaptcha_token: recaptchaToken,
    });
    if (response.data.access) {
      localStorage.setItem('access_token', response.data.access);
      if (response.data.user) {
        localStorage.setItem('user', JSON.stringify(response.data.user));
      }
    }
    return response.data;
  },

  register: async (firstName, lastName, email, password, passwordConfirm) => {
    // Utwórz username z emaila (przed @)
    const username = email.split('@')[0] + '_' + Date.now().toString().slice(-6);
    
    const response = await api.post('/accounts/register/', {
      username: username,
      first_name: firstName,
      last_name: lastName,
      email,
      password,
      password_confirm: passwordConfirm || password,
    });
    if (response.data.access) {
      localStorage.setItem('access_token', response.data.access);
      if (response.data.user) {
        localStorage.setItem('user', JSON.stringify(response.data.user));
      }
    }
    return response.data;
  },

  logout: () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('user');
  },

  getCurrentUser: () => {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },

  registerChimney: async (firstName, lastName, email, password, passwordConfirm, companyName, city, phone, description) => {
    // Utwórz username z emaila
    const username = email.split('@')[0] + '_' + Date.now().toString().slice(-6);
    
    const response = await api.post('/accounts/register-chimney/', {
      username: username,
      first_name: firstName,
      last_name: lastName,
      email,
      password,
      password_confirm: passwordConfirm || password,
      company_name: companyName,
      city,
      phone: phone || '',
      description: description || '',
    });
    if (response.data.access) {
      localStorage.setItem('access_token', response.data.access);
      if (response.data.user) {
        localStorage.setItem('user', JSON.stringify(response.data.user));
      }
    }
    return response.data;
  },

  isAuthenticated: () => {
    return !!localStorage.getItem('access_token');
  },

  /** Wyślij na email link do przejęcia wpisu (dla kominiarzy z importu). */
  requestClaimChimney: async (email) => {
    const response = await api.post('/accounts/request-claim-chimney/', { email: email.trim() });
    return response.data;
  },

  /** Ustaw hasło i aktywuj konto po wejściu w link z maila. Zapisuje token i user w localStorage. */
  confirmClaimChimney: async (uidb64, token, password, passwordConfirm) => {
    const response = await api.post(`/accounts/claim-chimney/${uidb64}/${token}/`, {
      password,
      password_confirm: passwordConfirm,
    });
    const data = response.data;
    if (data.access) {
      localStorage.setItem('access_token', data.access);
      if (data.user) {
        localStorage.setItem('user', JSON.stringify(data.user));
      }
    }
    return data;
  },
};
